<template>
  <div>
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        top: 0px;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
      class="d-none d-sm-flex"
    >
      <div style="width: 100%" class="mt-5 m-0">
        <h3 class="text-center text-white m-0">Tutor Grade & Class</h3>
        <br /><br />
      </div>
    </div>
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        top: 0px;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
      class="d-flex d-sm-none"
    >
      <div style="width: 100%" class="mt-3">
        <CCol sm="12">
          <br /><br />
          <br /><br />
          <br /><br />
          <br /><br />
        </CCol>
      </div>
    </div>
    <CCard class="custom-card h-100">
      <CRow>
        <CCol sm="12" class="justify-content-center m-0">
          <CContainer>
            <CCol sm="12" lg="12" class="custom-margin">
              <h5 class="text-left mt-4 text-black bold display-7-title">
                List Class & Grade
              </h5>
              <CRow class="justify-content-center">
                <div
                  class="mx-auto d-flex justify-content-center col-12 ml-1 mt-1"
                >
                  <div class="text-center custom-width-lg p-0 mb-3">
                    <CRow class="justify-content-center p-0 mt-1">
                      <CCol sm="12" lg="12" style="width: 100%">
                        <CRow>
                          <div style="width: 100% !important" class="m-2">
                            <div
                              style="text-align: left; width: 100%"
                              v-for="item in teacherSubGra"
                              v-bind:key="item.subjectName"
                            >
                              <CCard class="p-3 mt-2">
                                <CRow style="text-align: left">
                                  <CCol
                                    style="text-align: left"
                                    sm="12"
                                    lg="12"
                                    @click="toggle(item)"
                                  >
                                    <div
                                      style="text-align: left"
                                      class="item-text"
                                    >
                                      <span class="float-left">
                                        {{
                                          item.subjectName +
                                          " (" +
                                          item.gradeName +
                                          ")"
                                        }}
                                      </span>

                                      <span
                                        @click="
                                          DeleteSubject(item.teachingGradeId)
                                        "
                                        class="float-right"
                                      >
                                        <img
                                          src="../assets/img/delete_flaticon.png"
                                          height="25px"
                                          width="25px"
                                          class="float-right mr-2"
                                        />
                                      </span>
                                    </div>
                                  </CCol>
                                </CRow>
                              </CCard>
                            </div>
                          </div>

                          <hr class="bottom_expandbar" />
                          <CCol sm="12" lg="12" class="">
                            <h5
                              class="text-left text-black bold display-7-title"
                              style="width: 100%"
                            >
                              Assign new class & grade
                            </h5>
                          </CCol>
                            <CCol sm="12" lg="12" class="mt-4 mb-4">
                              <h5
                                class="text-left mt-3 text-black bold display-7"
                                style="width: 30%"
                              >
                                Subject
                              </h5>
                              <CCol sm="12" lg="12" class="mt-1">
                                <v-select
                                  v-model="SelectedSubject"
                                  :options="subjects"
                                  label="SubjectName"
                                  placeholder="--Please Select Subject--"
                                  required
                                ></v-select>
                              </CCol>
                            </CCol>
                            <hr class="bottom_expandbar" />
                            <CCol sm="12" lg="12" class="mb-4">
                              <h5
                                class="text-left text-black bold display-7"
                                style="width: 30%"
                              >
                                Grades
                              </h5>
                              <CCol sm="12" lg="12" class="mt-1">
                                <v-select
                                  v-model="SelectedGrade"
                                  :options="grades"
                                  label="GradeName"
                                  placeholder="--Please Select Level--"
                                  required
                                ></v-select>
                              </CCol>
                            </CCol>
                          <CCol sm="12" lg="12" class="mt-2 p-0">
                            <div v-if="SubmittedForm === true">
                              <h5>
                                We will update your profile.Wait a moment ......
                              </h5>
                              <br />
                              <CButton color="success" size="lg" block disabled
                                >Submitted</CButton
                              >
                            </div>
                            <div v-else>
                              <CButton
                                color="success"
                                size="lg"
                                block
                                :disabled="isDisabled"
                                @click="InsertNewSubject"
                                >Submit</CButton
                              >
                              <!-- <CButton
                                color="success"
                                class="custom-btn p-2"
                                size="lg"
                                :disabled="isDisabled"
                                @click="GoToPreviousPage()"
                                  style="width:50%"
                                >Back</CButton
                              > -->

                              <span
                                @click="GoToPreviousPage()"
                                class="btn btn-link mt-2"
                                ><u>Go Back to previous page</u></span
                              >
                            </div>
                          </CCol>
                        </CRow>
                      </CCol>
                    </CRow>
                  </div>
                </div>
              </CRow>
            </CCol>
          </CContainer>
        </CCol>
      </CRow>
    </CCard>
  </div>
</template>
<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import backgroundUrl from "../assets/img/backgroundTutor.png";
import backgroundBanner from "../assets/img/bgApps.jpg";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);
import _ from "lodash";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

export default {
  name: "Login",
  components: {
    PulseLoader,
  },
  data() {
    return {
      backgroundBanner,
      teacherSubGra: [],
      subjects: [],
      grades: [],
      SelectedSubject: "",
      SelectedGrade: "",
      SubmittedForm: false,
      Error: false,
    };
  },
  async mounted() {
    await this.GetTeacherSubjectGrade();
    await this.GetSubject();
    await this.GetGrade();
  },
  methods: {
    async GetTeacherSubjectGrade() {
      this.$API
        .get(
          this.$TeacherSubjectGrade + "?userId=" + this.$route.query.userId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.teacherSubGra = response.data;
          }
        });
    },
    async GetSubject() {
      this.$API
        .get(this.$ListSubject, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.subjects = response.data;
          }
        });
    },
    async GetGrade() {
      this.$API
        .get(this.$ListGrade, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.grades = response.data;
          }
        });
    },
    InsertNewSubject() {
      this.SubmittedForm = true;
      if (
        this.SelectedSubject.SubjectName === "" ||
        this.SelectedGrade.Id === ""
      ) {
        this.Error = true;
      } else {
        const formData = new FormData();

        formData.append("gradeId", this.SelectedGrade.Id);
        formData.append("subjectId", this.SelectedSubject.Id);
        formData.append("userId", this.$route.query.userId);

        return this.$API
          .post(this.$RegisterNewSubjectGrade, formData, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200 && response.data != null) {
              this.$router.go(0);
            }
          });
      }
    },
    DeleteSubject(teachingGradeId) {
      const formData = new FormData();
      console.log(teachingGradeId);
      formData.append("teachingGradeID", teachingGradeId);

      return this.$API
        .post(this.$DeleteTeacherSubjectGrade, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.$router.go(0);
          }
        });
    },
    GoToPageClassAndGrade() {
      this.$router.push(
        "/TeacherClassGrade?userId=" + this.$route.query.userId
      );
    },
    GoToPreviousPage() {
      this.$router.push(
        "/ProfessionalProfile?userId=" + this.$route.query.userId
      );
    },
  },
};
</script>
